import { render, staticRenderFns } from "./RegApplicationReject.vue?vue&type=template&id=1e07076a&scoped=true&"
import script from "./RegApplicationReject.vue?vue&type=script&lang=js&"
export * from "./RegApplicationReject.vue?vue&type=script&lang=js&"
import style0 from "./RegApplicationReject.vue?vue&type=style&index=0&id=1e07076a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e07076a",
  null
  
)

export default component.exports